exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 1200px){.tertiary-menu{margin-top:2em}}\n", ""]);

